import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import InfluencersList from './SidebarParts/InfluencersList'
import { CampaignContext } from '../../../../../contexts/CampaignContext'

export default observer(function DraftSidebar() {
  const { selectedScenario } = useContext(CampaignContext)

  return (
    <div className='w-[353px] h-full border-2 border-rb-widget-border dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode overflow-y-auto p-4'>
      <h2 className='font-bold text-xl mb-4 dark:text-white'>Drafts: {selectedScenario?.name}</h2>
      <InfluencersList />
    </div>
  )
})
